module.exports = __webpack_public_path__ + "img/s34New.48d21f1c.png";